// src/components/game/CoachingMessage.js
import React from 'react';

const CoachingMessage = ({ message, onDismiss }) => {
  if (!message) return null;
  
  return (
    <div className="bg-blue-50 border-l-4 border-blue-500 p-3 mb-4 text-blue-700 relative">
      <div className="flex items-start pr-8">
        <div className="text-blue-500 mr-2">💡</div>
        <div>{message}</div>
      </div>
      {onDismiss && (
        <button 
          onClick={onDismiss}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          aria-label="Dismiss tip"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default CoachingMessage;